import { Box, Link, Stack, Typography } from '@mui/material';
import TelegramIcon from '@mui/icons-material/Telegram';
import EmailIcon from '@mui/icons-material/Email';
import { CONFIG } from '../../../utils/config';

const contacts = [
    {
        label: 'Telegram',
        href: 'https://t.me/proxykeeper_help',
        icon: TelegramIcon,
    },
    {
        label: 'Telegram group',
        href: 'https://t.me/proxykeeper_news',
        icon: TelegramIcon,
    },
    {
        label: CONFIG.MAIL,
        href: `mailto:${CONFIG.MAIL}`,
        icon: EmailIcon,
    },
];

const ContactBox = () => {
    return (
        <Box>
            <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
                {contacts.map(({ label, href, icon: Icon }) => (
                    <Link
                        key={label}
                        href={href}
                        target={href.startsWith('mailto:') ? undefined : '_blank'}
                        rel={href.startsWith('mailto:') ? undefined : 'noreferrer'}
                        color="text.primary"
                        underline="none"
                        sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 1,
                            '&:hover': { color: 'primary.main' },
                        }}
                        aria-label={label}
                    >
                        <Icon fontSize="small" />
                        <Typography variant="body2" component="span">
                            {label}
                        </Typography>
                    </Link>
                ))}
            </Stack>
        </Box>
    );
};

export default ContactBox;